<template>
  <Card>
    <CardContent class="tw-pt-4 tw-h-[210px]">
      <div class="tw-flex tw-justify-between tw-mb-2.5">
        <CardTitle class="tw-uppercase tw-text-[0.8rem]">
          {{ t('profile.titles.default_signature') }}
        </CardTitle>

        <div>
          <Button
            variant="secondary"
            as="label"
            for="uploadSignature"
            class="tw-text-xs tw-cursor-pointer"
          >
            <i class="icon-upload"></i>
            {{ t('profile.titles.upload_signature') }}
          </Button>
        </div>
      </div>

      <div class="tw-text-[#3f4456]">
        <input
          type="file"
          id="uploadSignature"
          class="tw-hidden"
          accept="image/png, image/jpeg"
          @change="onSignatureUploaded"
        />

        <img
          v-if="currentUser?.signature"
          class="tw-h-[120px] tw-w-full tw-object-cover"
          :src="currentUser?.signature"
          :alt="t('profile.titles.signature')"
        />

        <label
          v-else
          for="uploadSignature"
          class="tw-flex tw-flex-col tw-items-center tw-p-3 tw-border tw-border-dashed tw-border-[#dcdcdc] tw-cursor-pointer"
        >
          <i class="icon-upload-cloud tw-text-2xl tw-mb-1"></i>

          <p class="tw-text-[0.9rem]">
            <strong>{{ t('profile.titles.upload_signature_button') }}</strong>
            {{ t('profile.titles.your_signature') }}
          </p>
          <p>JPEG, PNG, (max 10mb)</p>
        </label>
      </div>
    </CardContent>
  </Card>
</template>

<script setup lang="ts">
import { useUserStore } from '@/stores/user.store';
import { useFileValidation } from '@/_helpers/composables/file-validation.composable';
import { storeToRefs } from 'pinia';
import { ref, type Ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { Card, CardContent, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';

const { t } = useI18n();

const { currentUser } = storeToRefs(useUserStore());
const { editUserProfile } = useUserStore();

const isSignatureValid: Ref<boolean | null> = ref(null);

const onSignatureUploaded = async (e: any) => {
  const signatureFile: File = e.target.files[0];
  const { validateSize, validateTypeAndExtension } = useFileValidation();
  isSignatureValid.value =
    validateSize(signatureFile, 0, 10) && validateTypeAndExtension(signatureFile);

  if (isSignatureValid.value) {
    await editUserProfile({ signature: signatureFile });
  }
};
</script>

<style scoped>
/* Using Tailwind classes - no additional styles needed */
</style>
